"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var enums_1 = require("../../enums"); /// todo gutter var from the theme


exports.AllRightsReservedContainer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    bottom: 32px;\n    left: 32px;\n    z-index: 1;\n    font-size: 14px;\n    color: ", ";\n"], ["\n    position: fixed;\n    bottom: 32px;\n    left: 32px;\n    z-index: 1;\n    font-size: 14px;\n    color: ", ";\n"])), function (props) {
  return props.theme.colors.title;
});
exports.LinkText = styled_components_1.default(react_native_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: #411b67;\n    font-family: Ubuntu;\n    font-size: 14px;\n    margin-top: 18px;\n    cursor: pointer;\n    font-weight: 700;\n    line-height: 20px;\n    text-align: center;\n    text-transform: uppercase;\n"], ["\n    color: #411b67;\n    font-family: Ubuntu;\n    font-size: 14px;\n    margin-top: 18px;\n    cursor: pointer;\n    font-weight: 700;\n    line-height: 20px;\n    text-align: center;\n    text-transform: uppercase;\n"])));
exports.Title = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      fontSize = _a.fontSize,
      rest = __rest(_a, ["activeBreakpoint", "fontSize"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: Ubuntu;\n    color: #262b33;\n    line-height: 30px;\n"], ["\n    font-size: ", ";\n    font-family: Ubuntu;\n    color: #262b33;\n    line-height: 30px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      fontSize = _a.fontSize;
  return fontSize ? fontSize : activeBreakpoint && responsive_1.isSmall(activeBreakpoint) ? '22px' : '28px';
});
exports.TitleBold = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      fontSize = _a.fontSize,
      rest = __rest(_a, ["activeBreakpoint", "fontSize"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: Ubuntu;\n    font-weight: bold;\n    color: #262b33;\n    line-height: 44px;\n    ", "\n"], ["\n    font-family: Ubuntu;\n    font-weight: bold;\n    color: #262b33;\n    line-height: 44px;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            margin-top: " + (small ? 30 : 0) + "px;\n            font-size: " + (small ? 30 : 34) + "px;\n        ";
});
exports.TitleBoldCentered = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      fontSize = _a.fontSize,
      rest = __rest(_a, ["activeBreakpoint", "fontSize"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: Ubuntu;\n    font-weight: bold;\n    margin: auto auto auto auto;\n    padding: 0px 2%;\n    text-align: center;\n    color: #262b33;\n    line-height: 44px;\n"], ["\n    font-size: ", ";\n    font-family: Ubuntu;\n    font-weight: bold;\n    margin: auto auto auto auto;\n    padding: 0px 2%;\n    text-align: center;\n    color: #262b33;\n    line-height: 44px;\n"])), function (_a) {
  var fontSize = _a.fontSize,
      activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? '30px' : fontSize ? fontSize : '34px';
});
exports.TitleSmall = styled_components_1.default(react_native_1.Text)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: #262b33;\n    font-family: Roboto;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 26px;\n    margin-top: 24px;\n    margin-bottom: 15px;\n"], ["\n    color: #262b33;\n    font-family: Roboto;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 26px;\n    margin-top: 24px;\n    margin-bottom: 15px;\n"])));
exports.MainText = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: 460px;\n    font-family: Roboto;\n    text-align: left;\n    color: #262b33;\n    ", "\n"], ["\n    max-width: 460px;\n    font-family: Roboto;\n    text-align: left;\n    color: #262b33;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            font-size: " + (small ? '14px' : '18px') + ";\n            line-height: " + (small ? '14px' : '26px') + ";\n        ";
});
exports.TextCounter = styled_components_1.default(react_native_1.Text)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: #626971;\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n"], ["\n    color: #626971;\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n"]))); // todo refactor

exports.Image = responsive_1.withResponsiveMeta(styled_components_1.default(function (_a) {
  var height = _a.height,
      width = _a.width,
      rest = __rest(_a, ["height", "width"]);

  return react_1.default.createElement(react_native_1.ImageBackground, __assign({}, rest));
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: relative;\n    margin: auto;\n    ", "\n"], ["\n    position: relative;\n    margin: auto;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width,
      height = _a.height,
      marginTop = _a.marginTop,
      minHeight = _a.minHeight;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            width: " + (width ? width + "px" : '100%') + ";\n            height: " + (small ? height * 0.7 + "px" : height + "px") + ";\n            " + (small && minHeight ? "min-height: " + minHeight + ";" : '') + "\n            " + (marginTop && small ? "margin-top: " + marginTop + ";" : '') + "\n        ";
}));
exports.ImageFlaskBase = styled_components_1.default(react_native_1.ImageBackground)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    position: relative;\n    height: 361px;\n    margin: auto;\n"], ["\n    position: relative;\n    height: 361px;\n    margin: auto;\n"])));
exports.ImageFlaskScale = styled_components_1.default(exports.ImageFlaskBase)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-right: 8px;\n    width: 56px;\n"], ["\n    margin-right: 8px;\n    width: 56px;\n"])));
exports.ImageFlask = styled_components_1.default(exports.ImageFlaskBase)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 94px;\n"], ["\n    width: 94px;\n"])));
exports.EntireScreenBackground = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenHeight = _a.screenHeight,
      rest = __rest(_a, ["activeBreakpoint", "screenHeight"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    height: ", ";\n    background-image: url(", ");\n    background: linear-gradient(180deg, #fff4d8 0%, #f6e8d6 8%);\n    background-position: bottom center;\n    background-repeat: no-repeat;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    flex: 1;\n"], ["\n    height: ", ";\n    background-image: url(", ");\n    background: linear-gradient(180deg, #fff4d8 0%, #f6e8d6 8%);\n    background-position: bottom center;\n    background-repeat: no-repeat;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    flex: 1;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenHeight = _a.screenHeight,
      height = _a.height;
  return responsive_1.isSmall(activeBreakpoint) ? screenHeight : height;
}, function (_a) {
  var backgroundImage = _a.backgroundImage;
  return backgroundImage;
});
exports.ImageBackgroundCustom = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenHeight = _a.screenHeight,
      rest = __rest(_a, ["activeBreakpoint", "screenHeight"]);

  return react_1.default.createElement(exports.Image, __assign({}, rest));
})(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    background: linear-gradient(180deg, #fff4d8 0%, #f6e8d6 8%);\n    background-position: bottom;\n    background-repeat: no-repeat;\n    position: absolute;\n    ", "\n"], ["\n    background: linear-gradient(180deg, #fff4d8 0%, #f6e8d6 8%);\n    background-position: bottom;\n    background-repeat: no-repeat;\n    position: absolute;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenHeight = _a.screenHeight,
      backgroundImage = _a.backgroundImage;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            height: " + screenHeight + "px;\n            " + (backgroundImage ? "background-image: url(" + backgroundImage + ");" : '') + "\n            " + (small ? 'background-size: auto;' : '') + "\n            " + (small ? 'background-position-x: left;' : '') + "\n        ";
});
exports.Screen8ViewWrapper = styled_components_1.default(react_native_1.View)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    flex: 1 45%;\n    margin: 32px 10px auto 10px;\n"], ["\n    flex: 1 45%;\n    margin: 32px 10px auto 10px;\n"])));
exports.OneFourth = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      layoutType = _a.layoutType,
      rest = __rest(_a, ["activeBreakpoint", "layoutType"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    flex: ", ";\n    align-items: ", ";\n    margin: auto;\n"], ["\n    flex: ", ";\n    align-items: ", ";\n    margin: auto;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? '1 100%' : '1';
}, function (_a) {
  var layoutType = _a.layoutType;
  return layoutType === enums_1.ModuleSectionLayoutTypeEnum.image ? 'flex-start' : 'flex-end';
});
exports.ThreeFourth = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    flex: 3;\n    margin-top: ", "px;\n"], ["\n    flex: 3;\n    margin-top: ", "px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmallOrMedium(activeBreakpoint) ? 45 : 0;
});
exports.LabelWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    align-self: flex-start;\n    width: 70%;\n    margin: 12px;\n"], ["\n    align-self: flex-start;\n    width: 70%;\n    margin: 12px;\n"])));
exports.FlaskContainer = styled_components_1.default(exports.OneFourth)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    margin: ", ";\n    z-index: 2;\n"], ["\n    margin: ", ";\n    z-index: 2;\n"])), function (_a) {
  var layoutType = _a.layoutType,
      activeBreakpoint = _a.activeBreakpoint;
  return setFlaskContainerMargin(layoutType, activeBreakpoint);
});

function setFlaskContainerMargin(layoutType, activeBreakpoint) {
  if (responsive_1.isExtraLarge(activeBreakpoint)) {
    return layoutType === enums_1.ModuleSectionLayoutTypeEnum.image ? '0 100px 0 0' : '0 0 0 100px';
  }

  return 0;
}

exports.RectangleWrapper = styled_components_1.default(react_native_1.View)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    position: relative;\n    width: 100%;\n    margin-top: 16px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    position: relative;\n    width: 100%;\n    margin-top: 16px;\n"])));
exports.RectangleSwiperBackground = styled_components_1.default(react_native_1.Image)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    width: 30px;\n    height: 237px;\n    ", "\n"], ["\n    position: absolute;\n    z-index: 1;\n    width: 30px;\n    height: 237px;\n    ", "\n"])), function (_a) {
  var smallOrMedium = _a.smallOrMedium,
      large = _a.large;
  var top = smallOrMedium || large ? -12 : -14;
  var right = smallOrMedium || large ? -10 : 30;
  return "\n            top: " + top + "px;\n            right: " + right + "px;\n        ";
});
exports.OneColumn = styled_components_1.default(react_native_1.View)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    min-height: 300px;\n    position: relative;\n    flex-wrap: wrap;\n    flex-direction: row;\n"], ["\n    min-height: 300px;\n    position: relative;\n    flex-wrap: wrap;\n    flex-direction: row;\n"])));
exports.PartyIcon = styled_components_1.default(exports.Image)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    bottom: 32px;\n    right: -50px;\n    left: 0px;\n    top: 0px;\n    margin: auto;\n"], ["\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    bottom: 32px;\n    right: -50px;\n    left: 0px;\n    top: 0px;\n    margin: auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;